import React from 'react'
import {
  TextField
} from '@material-ui/core';

const DBUpdate = ({dbUpdate, handleChange}) => {
  return (
    <TextField  label="DB Update"
      variant="outlined"
      name={'db_update'}
      multiline
      fullWidth
      margin={'normal'}
      value={dbUpdate}
      onChange={({target}) => handleChange(target)}
      type="text" />
  )
}

export default DBUpdate
